import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import Button from '../components/atoms/Button';
import Icon from '../components/atoms/Icon';

const LiveInterviewCompletePage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  
  const { applicationId } = location.state || {};

  return (
    <div className="min-h-screen flex items-center justify-center bg-background-light dark:bg-background-dark p-6">
      <div className="max-w-4xl w-full">
        <div className="text-center">
          {/* Success Icon */}
          <div className="mb-8">
            <div className="w-24 h-24 bg-green-100 dark:bg-green-900/30 rounded-full flex items-center justify-center mx-auto mb-6">
              <Icon name="check_circle" size={64} className="text-green-600 dark:text-green-400" />
            </div>
            
            <h1 className="text-4xl font-black text-text-light-primary dark:text-text-dark-primary mb-4">
              Interview Completed!
            </h1>
            
            <p className="text-lg text-text-light-secondary dark:text-text-dark-secondary mb-8">
              Thank you for completing the live AI interview. Your responses have been recorded and will be reviewed by our hiring team.
            </p>
          </div>

          {/* Info Cards */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-8">
            <div className="bg-card-light dark:bg-card-dark rounded-lg p-6 border border-border-light dark:border-border-dark">
              <Icon name="schedule" size={32} className="text-primary mx-auto mb-3" />
              <h3 className="font-bold text-text-light-primary dark:text-text-dark-primary mb-2">
                What's Next?
              </h3>
              <p className="text-sm text-text-light-secondary dark:text-text-dark-secondary">
                Our team will review your interview within 2-3 business days
              </p>
            </div>
            
            <div className="bg-card-light dark:bg-card-dark rounded-lg p-6 border border-border-light dark:border-border-dark">
              <Icon name="email" size={32} className="text-primary mx-auto mb-3" />
              <h3 className="font-bold text-text-light-primary dark:text-text-dark-primary mb-2">
                Stay Updated
              </h3>
              <p className="text-sm text-text-light-secondary dark:text-text-dark-secondary">
                We'll send you an email with the results and next steps
              </p>
            </div>
          </div>

          {/* Interview Details */}
          {applicationId && (
            <div className="bg-panel-light dark:bg-panel-dark rounded-lg p-4 mb-8 border border-border-light dark:border-border-dark">
              <p className="text-sm text-text-light-secondary dark:text-text-dark-secondary">
                Application ID: <span className="font-mono text-text-light-primary dark:text-text-dark-primary">{applicationId}</span>
              </p>
            </div>
          )}

          {/* Actions */}
          <div className="flex gap-4 justify-center flex-wrap">
            <Button
              size="lg"
              onClick={() => navigate('/applications')}
              className="px-8"
            >
              <Icon name="description" size={20} className="mr-2" />
              View My Applications
            </Button>
            <Button
              size="lg"
              variant="outline"
              onClick={() => navigate('/jobs')}
            >
              Browse More Jobs
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LiveInterviewCompletePage;
